// extracted by css-extract-rspack-plugin
export default {"uspWrapper":"product-detail-fragment__BuyboxSeal_uspWrapper__CclT3","uspText":"product-detail-fragment__BuyboxSeal_uspText__E-oEw"};